import CaretDown from "phosphor-react-native/src/icons/CaretDown"

export { CaretDown as ChevronDown }
